const PREFIX = 'MODAL/';
export const OPEN_MODAL = `${PREFIX}OPEN_MODAL`;
export const CLOSE_MODAL = `${PREFIX}CLOSE_MODAL`;

// Select Video Modal
export const OPEN_SELECT_VIDEO_MODAL = `${PREFIX}OPEN_SELECT_VIDEO_MODAL`;
export const CLOSE_SELECT_VIDEO_MODAL = `${PREFIX}CLOSE_SELECT_VIDEO_MODAL`;

// Change Password Modal
export const OPEN_CHANGE_PASSWORD_MODAL = `${PREFIX}OPEN_CHANGE_PASSWORD_MODAL`;
export const CLOSE_CHANGE_PASSWORD_MODAL = `${PREFIX}CLOSE_CHANGE_PASSWORD_MODAL`;

// Edit Video Modal
export const OPEN_EDIT_VIDEO_MODAL = `${PREFIX}OPEN_EDIT_VIDEO_MODAL`;
export const CLOSE_EDIT_VIDEO_MODAL = `${PREFIX}CLOSE_EDIT_VIDEO_MODAL`;

// Delete Video Modal
export const OPEN_DELETE_VIDEO_MODAL = `${PREFIX}OPEN_DELETE_VIDEO_MODAL`;
export const CLOSE_DELETE_VIDEO_MODAL = `${PREFIX}CLOSE_DELETE_VIDEO_MODAL`;

// Monitoring Modals
export const OPEN_MONITORING_REFRESH_MODAL = `${PREFIX}OPEN_MONITORING_REFRESH_MODAL`;
export const CLOSE_MONITORING_REFRESH_MODAL = `${PREFIX}CLOSE_MONITORING_REFRESH_MODAL`;
export const OPEN_MONITORING_RESTART_MODAL = `${PREFIX}OPEN_MONITORING_RESTART_MODAL`;
export const CLOSE_MONITORING_RESTART_MODAL = `${PREFIX}CLOSE_MONITORING_RESTART_MODAL`;

// Reset Password
export const OPEN_RESET_PASSWORD_MODAL = `${PREFIX}OPEN_RESET_PASSWORD_MODAL`;
export const CLOSE_RESET_PASSWORD_MODAL = `${PREFIX}CLOSE_RESET_PASSWORD_MODAL`;

// Workout Program Exercise Modal
export const TOOGLE_WORKOUT_PROGRAM_MODAL = `${PREFIX}TOOGLE_WORKOUT_PROGRAM_MODAL`;
